export enum CalendarViewType {
  TimeGridDay = 'timeGridDay',
  TimeGridWeek = 'timeGridWeek',
  DayGridMonth = 'dayGridMonth',
  List = 'list'
}
